import {
  AppBar,
  createStyles,
  Grid,
  IconButton,
  makeStyles,
  Paper,
  Step,
  Stepper,
  StepButton,
  Theme,
  Toolbar,
  Typography,
  withStyles,
} from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import laqusImf from 'assets/laqus-imf-digital-xsmall.png';
import { CustomConnector } from 'components/customConnector';
import { HEADER_WIDTH } from 'components/header';
import { Button, LgSpace, MdSpace, SmSpace } from 'm2m.components';
import Documentos from 'pages/participantes/registro/documentos';
import InfoPrincipais from 'pages/participantes/registro/infoPrincipais';
import RepresentantesLegais from 'pages/participantes/registro/representantesLegais';
import ValidacaoCnpj from 'pages/participantes/registro/validacaoCnpj';
import Usuarios from 'pages/participantes/registro/usuarios';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RootState } from 'store/index';
import { resetParticipante, updateParticipante } from 'store/modules/participantes/registro';
import ParticipanteParser from 'utils/parsers/participanteParser';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconWrapper: {
      width: '112px',
      height: '112px',
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    icon: {
      width: '40px',
      height: '40px',
    },
  })
);

const StyledIconButton = withStyles({
  root: {
    padding: '12px 0',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
})(IconButton);

const FakeHeader: React.FC<{ children?: React.ReactNode; render: boolean }> = (props) => {
  return props.render ? (
    <>
      <AppBar position="fixed" color="secondary" style={{ height: '100vh', width: HEADER_WIDTH, left: 0 }}>
        <Toolbar disableGutters>
          <div
            style={{
              height: '100vh',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignContent: 'center' }}>
              <StyledIconButton disableFocusRipple>
                <img src={laqusImf} alt="Logo Laqus IMF digital" />
              </StyledIconButton>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Paper style={{ display: 'flex', minHeight: '100vh', height: '100%' }}>
        <main style={{ width: '100%', marginLeft: `calc(${HEADER_WIDTH} + 40px)` }}>{props.children}</main>
      </Paper>
    </>
  ) : (
    <>{props.children}</>
  );
};

type ComponentParams = { participanteId?: string };

const mapStateToProps = (state: RootState) => ({
  participante: state.participante,
  participanteApi: state.participanteApi,
});

const mapDispatchToProps = { updateParticipante, resetParticipante };

interface CadastroParticipanteProps {
  renderFakeHeader?: boolean;
  blockCategoria?: boolean;
}

type Props = RouteComponentProps<ComponentParams> &
  ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  CadastroParticipanteProps;

const Registro: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    participante,
    resetParticipante,
    updateParticipante,
    blockCategoria,
    participanteApi: { putUploadDoc, putParticipante, postParticipante, getParticipante, deleteUploadDoc },
  } = props;
  const { participanteId } = props.match.params;

  const [step, setStep] = useState<number>(0);
  const [infoPrincipaisValid, setInfoPrincipaisValid] = useState<boolean>(false);
  const [representantesLegaisValid, setRepresentantesLegaisValid] = useState<boolean>(false);
  const [usuariosValid, setUsuariosValid] = useState<boolean>(false);
  const [documentosValid, setDocumentosValid] = useState<boolean>(false);
  const [dataVencimentoPreenchido, setDataVencimentoPreenchido] = useState<boolean>(false);
  const [finished, setFinished] = useState<boolean>(false);
  const steps = ['Informações Principais', 'Representantes Legais', 'Usuários', 'Documentos'];

  const handleNextStep = () => {
    if (step === steps.length) return;
    else setStep(step + 1);
  };

  const handlePreviousStep = () => {
    if (step === 1) return;
    else setStep(step - 1);
  };

  const isStepCompleted = (index: number) => {
    switch (index) {
      case 1:
        return infoPrincipaisValid;
      case 2:
        return representantesLegaisValid;
      case 3:
        return usuariosValid;
      case 4:
        return documentosValid;
      default:
        return false;
    }
  };

  const handleEditSubmit = async () => {
    
    if (!participanteId) return;
    let documentosSendOk = true;
    
    const participanteRequest = ParticipanteParser.stateToCadastroParticipanteApiRequest(participante);
    await putParticipante(dispatch, participanteId, participanteRequest, true);
    
    for (const documentoExcluir of participante.documentosExcluir) {
      documentoExcluir.remoteFileInfo?.id &&
        (await deleteUploadDoc(dispatch, participanteId, documentoExcluir.remoteFileInfo.id, true));
    }

    for (const document of participante.documentos) {
      try{
        
          if (document.file) await putUploadDoc(dispatch, participanteId, document.type, document.file, document.dataVencimento, true);
      }
      catch(error){
        documentosSendOk = false;
      }
    }

    if (!documentosSendOk)
    {
      throw 'Um dos documentos não foi possível editar!';
    }

  };

  const handleSubmit = async () => {
    try {
      if (participanteId) {
        
        await handleEditSubmit();
      } else {
        const participante = await submitParticipante();
        await submitParticipanteDocuments(participante.id);
      }
      setFinished(true);
    } catch (error) {}
  };

  const submitParticipante = async () => {
    const request = ParticipanteParser.stateToCadastroParticipanteApiRequest(participante);

    return await postParticipante(dispatch, request, true);
  };

  const submitParticipanteDocuments = async (participanteId: string) => {
    if (participanteId) {
      for (const document of participante.documentos) {
        if (document.file) await putUploadDoc(dispatch, participanteId, document.type, document.file, document.dataVencimento, true);
      }
    }
  };

  const handleReset = () => {
    setStep(0);
    setFinished(false);
    resetParticipante();
  };

  const handleReturnToList = () => {
    handleReset();
    props.history.push('/solicitacoes');
  };

  useEffect(() => {
    resetParticipante();
  }, [resetParticipante]);

  useEffect(() => {
    if (participanteId) {
      setStep(1);
      getParticipante(dispatch, participanteId, true)
        .then((response) => {
          if (response) {
            updateParticipante(ParticipanteParser.apiResponseToParticipanteState(response));
          }
        })
        .catch(() => {});
    }
  }, [participanteId, dispatch, updateParticipante, getParticipante]);

  const enableSubmit = infoPrincipaisValid && representantesLegaisValid && usuariosValid && documentosValid && dataVencimentoPreenchido;

  return (
    <>
      <FakeHeader render={!!props.renderFakeHeader}>
        <LgSpace />
        <Typography variant="h1">{participanteId ? 'Editar Participante' : 'Cadastro de Participante'}</Typography>
        <MdSpace />
        {!!props.renderFakeHeader && (
          <Button onClick={handleReturnToList} variant="contained" color="primary">
            {'Voltar para a página inicial'}
          </Button>
        )}
        <MdSpace />
        {step !== 0 && (
          <Stepper
            nonLinear
            activeStep={step - 1}
            connector={<CustomConnector />}
            style={{ padding: 0, display: 'flex', flexWrap: 'wrap' }}
          >
            {steps.map((label, index) => {
              return (
                <Step key={label} onClick={() => setStep(index + 1)}>
                  <StepButton completed={isStepCompleted(index + 1)}>{label}</StepButton>
                </Step>
              );
            })}
          </Stepper>
        )}
        <MdSpace />
        {finished ? (
          <Grid container direction="column" justify="center" alignItems="center">
            <div className={classes.iconWrapper}>
              <CheckCircle className={classes.icon} color="secondary" />
            </div>
            <SmSpace />
            {participanteId ? (
              <Typography variant="h3">{'Edição de Participante realizada com sucesso!'}</Typography>
            ) : (
              <>
                <Typography variant="h3">{'Participante cadastrado com sucesso!'}</Typography>
                <SmSpace />
                <Typography variant="body2">
                  {'Solicitação de cadastro de participante realizada com sucesso!'}
                </Typography>
                <Typography variant="body2">
                  {'Em breve o time de Operações da Laqus confirmará seu acesso.'}
                </Typography>
              </>
            )}
            <MdSpace />
          </Grid>
        ) : (
          <>
            {step === 0 && <ValidacaoCnpj onSubmit={handleNextStep} />}
            {step === 1 && <InfoPrincipais isStepFulfilled={setInfoPrincipaisValid} blockCategoria={blockCategoria} />}
            {step === 2 && <RepresentantesLegais isStepFulfilled={setRepresentantesLegaisValid} />}
            {step === 3 && <Usuarios isEdit={participanteId !== undefined} isStepFulfilled={setUsuariosValid} />}
            {step === 4 && <Documentos isStepFulfilled={setDocumentosValid} isDataVencimentoPreenchido={setDataVencimentoPreenchido} participanteId={participanteId} />}
            <MdSpace />
            {!!step && (
              <Grid container justify="center" spacing={8} alignItems="center" style={{ width: '100%' }}>
                <Grid item>
                  <Button variant="outlined" disabled={step === 1} onClick={handlePreviousStep}>
                    {'Passo Anterior'}
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="outlined" disabled={step === steps.length} onClick={handleNextStep}>
                    {'Próximo Passo'}
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" disabled={!enableSubmit} color="primary" onClick={handleSubmit}>
                    {'Concluir'}
                  </Button>
                </Grid>
              </Grid>
            )}
          </>
        )}
        <MdSpace />
      </FakeHeader>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Registro));